<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6" md="3" lg="3" xl="2">
        <v-select
          label="Tahun"
          v-model="year"
          :items="years"
          outlined
          flat
          hide-details
        />
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3" xl="2">
        <v-select
          v-model="category"
          label="Kategori"
          :items="categories"
          item-value="nomor"
          item-text="kategori"
          outlined
          flat
          hide-details
        />
      </v-col>
      <v-col v-if="showFilter" cols="12" sm="6" md="3" lg="3" xl="2">
        <v-select
          label="Jurusan"
          v-model="jurusan"
          :items="jurusans"
          item-value="nomor"
          item-text="jurusan"
          outlined
          flat
          hide-details
        />
      </v-col>
      <v-col v-if="showFilter" cols="12" sm="6" md="3" lg="3" xl="2">
        <v-select
          v-model="prodi"
          :items="prodies"
          item-value="nomor"
          item-text="prodi"
          label="Program studi"
          outlined
          flat
          hide-details
        />
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3" xl="2">
        <v-select
          label="Kriteria"
          v-model="kriteria"
          :items="kriterias"
          item-value="nomor"
          item-text="kriteria"
          outlined
          flat
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>No</th>
                <th>Sub Kriteria</th>
                <th class="text-center">Status</th>
                <th class="text-center">Aksi</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in rekaps" :key="item.nomor">
                <td>{{ i + 1 }}</td>
                <td>{{ item.subkriteria }}</td>
                <td class="text-center">
                  <v-btn
                    :class="item.valid ? 'success' : 'warning'"
                    class="text-none"
                    dark
                    small
                    text
                  >
                    <v-icon size="18">
                      {{
                        item.valid
                          ? "mdi-bookmark-check"
                          : "mdi-bookmark-remove"
                      }}
                    </v-icon>
                    <span class="caption">
                      {{ item.valid ? "Valid" : "Belum Valid" }}
                    </span>
                  </v-btn>
                </td>
                <td class="text-center">
                  <v-btn
                    small
                    text
                    class="purple text-none"
                    dark
                    :to="'/form/' + kriteria + '/' + item.nomor"
                  >
                    <v-icon size="18">mdi-format-float-left</v-icon>
                    <span class="hidden-xs-only ml-1 caption">Lihat Form</span>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import filterYear from "@/mixins/filter-year.js";
import filterCategory from "@/mixins/filter-category.js";
import filterJurusan from "@/mixins/filter-jurusan.js";
import filterProdi from "@/mixins/filter-prodi.js";
import filterKriteria from "@/mixins/filter-kriteria.js";
import Axios from "axios";
export default {
  mixins: [
    filterYear,
    filterJurusan,
    filterCategory,
    filterProdi,
    filterKriteria
  ],
  name: "rekap",
  data() {
    return {
      showFilter: false,
      rekaps: []
    };
  },
  watch: {
    category(v) {
      if (v === 1) {
        this.showFilter = false;
        this.jurusan = null;
        this.prodi = null;
        this.getCriteriasByCategory();
      } else {
        this.showFilter = true;
        this.jurusan = this.jurusans.length > 0 ? this.jurusans[0].nomor : null;
        this.getCriteriasByJurusanAndProdi();
      }
    },
    prodi(v) {
      if (v) {
        this.getCriteriasByJurusanAndProdi();
      }
    },
    kriteria(v) {
      Axios.get(
        process.env.VUE_APP_API_URL + "/rekap/list.php?kriteria=" + v
      ).then(res => {
        this.rekaps = res.data;
      });
    }
  }
};
</script>
